import moment from 'moment'
import api from '../api'
// import store from '../store'
// import analytics from '../utils/cdpAnalytics'

const MAX_ROUND_TRIP_TIME = 2000// 2 seconds
const RETRY_INTERVAL = 10000 // 10 seconds

export default function syncClock() {
  const sentTime = moment()
  return (dispatch) => api.fetch('/current-time/')
    .then((response) => {
      const receivedTime = moment()
      const roundTripTime = receivedTime.diff(sentTime)
      const serverTime = moment(response.currentTime)
      const clockOffset = (serverTime.add(roundTripTime / 2)).diff(receivedTime)

      if (roundTripTime < MAX_ROUND_TRIP_TIME) {
        dispatch({ type: 'CLOCK_SYNC_SUCCESS', clockOffset })
        // 2025-07-30 Segment tracking disabled for now
        // const { session } = state
        // const state = store.getState()
        // analytics.track('Sync Clock', {
        //   offsetInMilliseconds: clockOffset,
        //   session,
        // })
      } else {
        setTimeout(() => { // Start the timer
          dispatch(syncClock())
        }, RETRY_INTERVAL)
      }
    })
}
